/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ResetPasswordPayload model module.
 * @module model/ResetPasswordPayload
 * @version v1
 */
export class ResetPasswordPayload {
  /**
   * Constructs a new <code>ResetPasswordPayload</code>.
   * @alias module:model/ResetPasswordPayload
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ResetPasswordPayload</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ResetPasswordPayload} obj Optional instance to populate.
   * @return {module:model/ResetPasswordPayload} The populated <code>ResetPasswordPayload</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ResetPasswordPayload();
      if (data.hasOwnProperty('token_id'))
        obj.token_id = ApiClient.convertToType(data['token_id'], 'String');
      if (data.hasOwnProperty('password'))
        obj.password = ApiClient.convertToType(data['password'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} token_id
 */
ResetPasswordPayload.prototype.token_id = undefined;

/**
 * @member {String} password
 */
ResetPasswordPayload.prototype.password = undefined;

